import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .LpaChangeStatusForm {
    &__btns {
      margin-top: 24px;

      :global(.DefaultButton:last-child) {
        margin-left: rem(${isRTL ? '0' : '20px'});
        margin-right: rem(${isRTL ? '20px' : '0'});
      }
    }
  }
`;

export { staticStyles };
